import React from 'react';
import { StyledMapEmbedWrapper } from './GoogleMapEmbed.styles';
import { getConfig } from '@config';

export interface SystemProps
  extends Readonly<{
    height?: string;
    width?: string;
  }> {}

interface InternalGoogleMapEmbedProps
  extends Readonly<{
    place?: string;
    lat?: number;
    lng?: number;
    address?: string;
    name?: string;
    a11yTitle: string;
  }> {}

export interface GoogleMapEmbedProps extends Readonly<InternalGoogleMapEmbedProps>, SystemProps {}

function _formatPlaceQuery(place?: string, name?: string, address?: string) {
  const value = [name, address].filter(item => item).join(',');
  return place ? { key: 'q', value: `place_id:${place}` } : value ? { key: 'q', value } : null;
}

function _formatCenterLocaton(lat?: number, lng?: number) {
  return lat && lng ? { key: 'center', value: `${lat},${lng}` } : null;
}

const GOOGLE_EMBED_URL = 'https://www.google.com/maps/embed/v1/place';

const GoogleMapEmbed: React.FC<GoogleMapEmbedProps> = ({ lat, lng, a11yTitle, width = '', height = '', place = '', name = '', address = '', ...restProps }) => {
  const url = new URL(GOOGLE_EMBED_URL);
  url.searchParams.append('key', getConfig().googleMapsApiKey);
  url.searchParams.append('zoom', '10');

  [_formatPlaceQuery(place, name, address), _formatCenterLocaton(lat, lng)].forEach(entry => {
    if (entry) {
      url.searchParams.append(entry.key, entry.value);
    }
  });

  return url.searchParams.has('q') || url.searchParams.has('center') ? (
    <StyledMapEmbedWrapper
      {...restProps}
      title={a11yTitle}
      width={width}
      height={height}
      src={url.toString()}
      loading="lazy"
    />
  ) : null;
};

GoogleMapEmbed.displayName = 'GoogleMapEmbed';

export { GoogleMapEmbed };
